module.exports = __webpack_public_path__ + "img/icon_present.524d5fcf.svg";